<!-- 价值观卡 - 盲抽 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div class="game-1-box">
        <!-- <div class="game-1-box-title">当前：第1/8页</div> -->
        <div class="game-1-box-list">
          <div class="game-1-box-list-wheel-title">
            {{ gameInfo.cateName }}
          </div>
          <div class="game-1-box-list-wheel-box">
            <LuckyWheel
              ref="myLucky"
              width="300px"
              height="300px"
              :prizes="prizes"
              :blocks="blocks"
              :buttons="buttons"
              :defaultConfig="defaultConfig"
              @click.native="wheelHandle"
              @end="endCallback"
            />
          </div>

          <div class="game-1-box-list-divider"></div>

          <!-- <CardReverseAndConfirm
            :value.sync="formValue.playerCardList[formValue.roleTab]"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            :playerId="formValue.roleTab"
            :playerName="formValue.roleName"
            :sizeType="sizeType"
            :gameStatus="gameStatus"
            :showReturn="false"
            @confirm="confirmHandle"
          /> -->
          <div class="game-1-box-list-select">
            <Grid :column-num="sizeType != 'small' ? 3 : 4" :border="false">
              <GridItem
                v-for="(subitem, subindex) in formValue.selectCardList"
                :key="subindex"
              >
                <div
                  class="game-1-box-list-select-card-item"
                  :class="{
                    active: selectActiveCard == subitem.id,
                    small: sizeType == 'small',
                    middle: sizeType == 'middle',
                  }"
                  @click="selectActiveCard = subitem.id"
                >
                  <VanImage
                    height="100%"
                    :src="
                      subitem.isFront != 1
                        ? subitem.reverseImg
                        : subitem.frontImg
                    "
                    fit="cover"
                    radius="5"
                  />
                </div>
              </GridItem>
            </Grid>
            <!-- 选中的卡片按钮 -->
            <div class="game-1-box-list-select-btns">
              <NfButton
                color="rgb(255,211,94)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="revertCardHandle"
                >放回卡片</NfButton
              >

              <NfButton
                color="rgb(172,185,233)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="confirmHandle"
                >确认选择</NfButton
              >
            </div>
          </div>
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import { Swipe, SwipeItem, Image as VanImage, Grid, GridItem } from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import CardReverseAndConfirm from "@/components/game-comm/CardReverseAndConfirm.vue";
import WheelBg from "@/assets/game/wheel/bg.png";
import WheelStart from "@/assets/game/wheel/start.png";
import WheelMp3 from "@/assets/game/wheel/wheel_music.mp3";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    cardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sizeType: {
      type: String,
      default: "big",
    },
    gameStatus: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      onRotation: false, // 记录当前是否正在旋转，如果正在旋转，就不能继续点击了
      result: {}, //结果文案
      nextStatus: {}, //转盘的下一个状态
      selectCardList: [],
      selectActiveCardList: [],
      selectActiveCard: null,
      // 使用lukky-wheel
      blocks: [
        {
          padding: "22px",
          imgs: [
            {
              src: WheelBg,
              width: "100%",
              height: "100%",
              rotate: true,
            },
          ],
        },
      ],
      prizes: [
        // 25个不同背景颜色
        { background: "#f2b8b8", fonts: [{ text: "" }], index: 0 },
        { background: "#f2e2b8", fonts: [{ text: "" }], index: 1 },
        { background: "#f2f2b8", fonts: [{ text: "" }], index: 2 },
        { background: "#b8f2b8", fonts: [{ text: "" }], index: 3 },
        { background: "#b8f2e2", fonts: [{ text: "" }], index: 4 },
        { background: "#b8f2f2", fonts: [{ text: "" }], index: 5 },
        { background: "#b8e2f2", fonts: [{ text: "" }], index: 6 },
        { background: "#b8b8f2", fonts: [{ text: "" }], index: 7 },
        { background: "#e2b8f2", fonts: [{ text: "" }], index: 8 },
        { background: "#f2b8e2", fonts: [{ text: "" }], index: 9 },
        { background: "#f2b8b8", fonts: [{ text: "" }], index: 10 },
        { background: "#f2e2b8", fonts: [{ text: "" }], index: 11 },
        { background: "#f2f2b8", fonts: [{ text: "" }], index: 12 },
        { background: "#b8f2b8", fonts: [{ text: "" }], index: 13 },
        { background: "#b8f2e2", fonts: [{ text: "" }], index: 14 },
        { background: "#b8f2f2", fonts: [{ text: "" }], index: 15 },
        { background: "#b8e2f2", fonts: [{ text: "" }], index: 16 },
        { background: "#b8b8f2", fonts: [{ text: "" }], index: 17 },
        { background: "#e2b8f2", fonts: [{ text: "" }], index: 18 },
        { background: "#f2b8e2", fonts: [{ text: "" }], index: 19 },
        { background: "#f2b8b8", fonts: [{ text: "" }], index: 20 },
        { background: "#f2e2b8", fonts: [{ text: "" }], index: 21 },
        { background: "#f2f2b8", fonts: [{ text: "" }], index: 22 },
        { background: "#b8f2b8", fonts: [{ text: "" }], index: 23 },
        { background: "#b8f2e2", fonts: [{ text: "" }], index: 24 },
      ],
      buttons: [
        {
          radius: "25%",
          imgs: [
            {
              src: WheelStart,
              width: "100%",
              top: "-100%",
            },
          ],
          pointer: true,
          background: "rgb(203,78,118)",
          fonts: [{ text: "开始", top: "-10px" }],
        },
      ],
      defaultConfig: {
        gutter: "1px",
        decelerationTime: 800,
      },
      wheelStatus: false,
      wheelLock: false,
      wheelMusic: null,

    };
  },
  mounted() {},
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    CardReverseAndConfirm,
  },
  methods: {
    afterTransitionend() {
      setTimeout(() => {
        // 等闪烁三下结束
        this.onRotation = false; //结束旋转状态
        // this.result = nextStatus.text; //更新结果文案为下一步状态的文案
        // 如果当前玩家已经抽过卡牌，则不再记录
        const isExist = this.formValue.selectCardList.find(
          (item) => item.cardName == this.result.cardName
        );

        if (isExist) {
          this.$dialog.message("该卡牌已抽取过，请重新抽卡");
          return;
        } else {
          // 输出结果
          this.$dialog.message(this.nextStatus.text);
          this.formValue.selectCardList.push({
            ...this.result,
            brandStatus: false,
          });
        }
      }, 300);
    },
    //获得当前结果
    getReward() {
      let getEle = document.getElementsByClassName.bind(document);
      let pointer = getEle("game-1-box-list-wheel-panel-pointer")[0]; //获取指针元素
      let currentDeg = this.nextStatus.deg ? this.nextStatus.deg : 0; //如果当前已有角度则获取角度 无则为0
      // 转三圈到四圈
      let rotateDeg = Math.random() * 360 + 1080;
      currentDeg += rotateDeg; //加上旋转的随机角度
      this.result = this.cardList[Math.floor(((currentDeg + 20) % 360) / 40)]; //获取结果位置的卡牌
      this.nextStatus = {
        deg: currentDeg,
        text: `本次您抽中了${this.result.cardName}，点击抽取下一张卡牌`,
      }; //更新下一步状态
      pointer.style.transform = `rotateZ(${this.nextStatus.deg}deg)`; //旋转+动画
    },
    //重置
    reset() {
      this.onRotation = false; //关闭旋转状态
      this.result = {}; //结果清空
    },
    // 转动转盘
    handleClick() {
      // 如果超出最大可抽
      // 如果超出最大可抽取的数量则提示
      if (this.formValue.selectCardList.length >= this.gameInfo.extractNum) {
        this.$dialog.message(
          "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
        );
        return;
      }

      if (this.onRotation) return; //如果在旋转 不执行

      this.reset(); //重置
      this.onRotation = true; //开启旋转状态 禁止点击事件
      this.getReward(); //获取结果
    },
    resetCardStatus() {
      this.reset();
    },
    // 确认选择
    confirmHandle(data) {
      this.$dialog.message("您可提示用户点击此按钮进行提交操作，需要全部选中才能进行确认");
    },
    revertCardHandle() {
      const index = this.formValue.selectCardList.findIndex(
        (item) => item.id == this.selectActiveCard
      );
      if (index != -1) {
        this.formValue.selectCardList.splice(index, 1);
      } else {
        this.$dialog.message("请选择需要放回的卡牌");
      }
    },

    // 使用lukky-wheel
    startCallback() {
      console.log("触发");

      // 如果超出最大可抽取的数量则提示
      if (this.formValue.selectCardList.length >= this.gameInfo.extractNum) {
        this.$dialog.message("已达到最大可抽取数量");
        this.wheelStatus = false;
        this.buttons[0].fonts[0].text = "开始";
        this.wheelMusic.pause();
        return;
      }

      this.wheelStatus = true;
      this.$refs.myLucky.play();
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      this.wheelStatus = false;
      this.wheelLock = false;
      this.buttons[0].fonts[0].text = "开始";
      this.wheelMusic.pause();

      console.log(prize);
      // 同步抽中对应索引的卡牌
      this.result = this.cardList[prize.index];
      this.nextStatus = {
        text: `本次您抽中了${this.result.cardName}，点击抽取下一张卡牌`,
      }; //更新下一步状态
      // 如果当前玩家已经抽过卡牌，则不再记录
      const isExist = this.formValue.selectCardList.find(
        (item) => item.cardName == this.result.cardName
      );

      if (isExist) {
        this.$dialog.message("该卡牌已抽取过，请重新抽卡");
        return;
      } else {
        // 输出结果
        this.$dialog.message(this.nextStatus.text);
        this.formValue.selectCardList.push({
          ...this.result,
        });
        console.log(this.result);
      }
    },
    wheelHandle() {
      if (this.wheelLock) {
        this.$dialog.message("正在抽奖中，请稍后");
        return;
      }
      if (this.wheelStatus) {
        this.$dialog.message("即将停止转动，请稍后");

        this.wheelLock = true;
        // 从prizes的长度中随机一个索引
        const index = Math.floor(Math.random() * this.prizes.length);
        this.$refs.myLucky.stop(index);
        return;
      } else {
        this.buttons[0].fonts[0].text = "停止";
        this.palyAudio();
        this.$dialog.message("开始抽奖，再次点击停止转动");
        this.startCallback();
      }
      // this.startCallback();
    },
    palyAudio() {
      this.wheelMusic = new Audio();
      this.wheelMusic.src = WheelMp3;
      this.wheelMusic.loop = true;
      this.wheelMusic.play();
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  watch: {
    // "formValue.roleTab"(val) {
    //   this.selectCardList = this.formValue.playerCardList[val];
    // },
    // // 为了让它触发深度监听，临时解决方案
    // "formValue.playerCardList": {
    //   handler(val) {
    //     this.selectActiveCardList = val[this.formValue.roleTab];
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }
    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }
      &-item {
        box-sizing: border-box;
        border-radius: 0.2rem;
        // overflow: hidden;
        height: 2.9rem;
        width: 100%;
        position: relative;

        &-open {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          border-radius: 50%;
          width: 0.6rem;
          height: 0.6rem;
          background: #eee;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .active {
        border: 0.06rem solid #666eee;
      }
      &-wheel {
        position: relative;
        box-sizing: revert;
        height: 200px;
        width: 200px;
        padding: 20px;
        background-color: rgb(66, 161, 254);
        box-shadow: #000000 0px 0px 10px;
        border-radius: 50%;
        margin: 20px auto;

        &-box {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &-light {
          position: absolute;
          height: 10px;
          width: 10px;
          border-radius: 50%;
          top: 5px;
          left: 115px;
          transform-origin: 5px 115px;

          &-twinkling {
            animation: 1s twinkling 3, 100ms 3s twinkling 3;
          }

          &:nth-child(3n) {
            background-color: rgb(89, 255, 179);
          }

          &:nth-child(3n + 1) {
            background-color: rgb(255, 141, 148);
          }

          &:nth-child(3n + 2) {
            background-color: rgb(255, 209, 50);
          }

          &:nth-child(2) {
            transform: rotate(40deg);
          }

          &:nth-child(3) {
            transform: rotate(80deg);
          }

          &:nth-child(4) {
            transform: rotate(120deg);
          }

          &:nth-child(5) {
            transform: rotate(160deg);
          }

          &:nth-child(6) {
            transform: rotate(200deg);
          }

          &:nth-child(7) {
            transform: rotate(240deg);
          }

          &:nth-child(8) {
            transform: rotate(280deg);
          }

          &:nth-child(9) {
            transform: rotate(320deg);
          }
        }

        &-panel {
          position: relative;
          height: 200px;
          width: 200px;
          background-color: #b7b7b7;
          border-radius: 100px;

          &-sector {
            position: absolute;
            left: 100px;
            top: 0px;
            width: 100px;
            height: 200px;
            font-size: 14px;
            border-radius: 0px 100px 100px 0;
            overflow: hidden;
            transform-origin: left center;

            &:nth-child(1) {
              transform: rotate(-20deg);
            }

            &:nth-child(2) {
              transform: rotate(20deg);
            }

            &:nth-child(3) {
              transform: rotate(60deg);
            }

            &:nth-child(4) {
              transform: rotate(100deg);
            }

            &:nth-child(5) {
              transform: rotate(140deg);
            }

            &:nth-child(6) {
              transform: rotate(180deg);
            }

            &:nth-child(7) {
              transform: rotate(220deg);
            }

            &:nth-child(8) {
              transform: rotate(260deg);
            }

            &:nth-child(9) {
              transform: rotate(300deg);
            }

            &:nth-child(3n + 1) &-inner {
              background: rgb(255, 209, 50);
            }

            &:nth-child(3n + 2) &-inner {
              background: rgb(188, 202, 255);
            }

            &:nth-child(3n) &-inner {
              background: rgb(91, 222, 255);
            }

            &-inner {
              box-sizing: revert;
              font-size: 0.25rem;
              text-align: center;
              display: block;
              width: 40px;
              padding: 5px 3px 0 57px;
              height: 195px;
              transform: translateX(-100px) rotate(40deg);
              transform-origin: right center;
              border-radius: 100px 0 0 100px;

              span {
                display: block;
                transform-origin: center;
                transform: rotate(-19deg);
                color: #333;
                font-weight: 600;
                position: relative;
                left: 0px;
                bottom: -21px;
              }
            }
          }

          &-pointer {
            background-image: url("~@/assets/game/wheel/start.png");
            background-size: contain;
            box-sizing: revert;
            position: absolute;
            left: 74px;
            top: 74px;
            z-index: 10;
            height: 40px;
            width: 40px;
            padding: 6px;
            color: rgba(102, 102, 102, 1);
            line-height: 15px;
            font-size: 14px;
            text-align: center;
            // background-color: #ff5350;
            border-radius: 50%;
            border: 1px solid #ff5350;

            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
            transform-style: preserve-3d;

            &-trans {
              transition: transform 3s cubic-bezier(0.2, 0.93, 0.43, 1);
            }

            &::after {
              // content: url("~@/assets/game/wheel/jian.png");
              content: "";
              position: absolute;
              left: -10px;
              top: -76px;
              display: block;
              width: 70px;
              height: 125px;
              background: url("~@/assets/game/wheel/jian.png");
              background-size: contain;
              background-repeat: no-repeat;
              transform: translateZ(-1px);
            }
          }
        }
      }

      &-btns {
        display: flex;
        justify-content: space-between;
        margin-top: 0.2rem;
        &-btn {
          margin: 0 0.2rem;
        }
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}

@keyframes twinkling {
  50% {
    background: transparent;
  }
}
</style>
